import { ChevronDown, ChevronRight } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { AnimatedCollapsible } from "../../../../helper/components/AnimatedCollapsible.js";
import { LegacyIconRenderer } from "../../../../helper/components/LegacyIconRenderer.js";
import { GroupTitle } from "../../../groupTitle/GroupTitle.js";
import { Typography } from "../../../typography/Typography.js";
import styles from "./AccordionItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AccordionItem = ({
  children,
  className,
  icon: optionalIcon,
  id,
  onOpenChange,
  open,
  state,
  title,
  titleVariant = 'h3',
  titleHtmlTag,
  variant = 'GRAY',
  barItemsLeft,
  barItemsRight,
  condensed
}) => {
  const disabled = state === 'disabled';
  const highlighted = state === 'highlighted';
  const classes = classnames(styles.accordionItem, {
    [styles.disabled]: disabled,
    [styles.highlighted]: highlighted,
    [styles.open]: open,
    [styles.condensed]: condensed
  }, styles[variant], className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx("button", {
      "aria-expanded": open,
      "aria-controls": `section-${id}`,
      disabled: disabled,
      id: `label-${id}`,
      onClick: onOpenChange,
      type: "button",
      className: styles.button,
      children: condensed ? /*#__PURE__*/_jsxs("div", {
        className: styles.groupTitleWrapper,
        children: [/*#__PURE__*/_jsx(ChevronRight, {
          className: classnames(styles.condensedIcon, {
            [styles.color]: variant
          })
        }), /*#__PURE__*/_jsx(GroupTitle, {
          title: title,
          color: variant
        })]
      }) : /*#__PURE__*/_jsxs("div", {
        className: styles.headline,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.headlineSectionLeft,
          children: [/*#__PURE__*/_jsxs(Typography, {
            variant: titleVariant,
            htmlTag: titleHtmlTag,
            margin: false,
            children: [optionalIcon && /*#__PURE__*/_jsx("div", {
              className: styles.optionalIcon,
              children: /*#__PURE__*/_jsx(LegacyIconRenderer, {
                icon: optionalIcon
              })
            }), /*#__PURE__*/_jsx("span", {
              children: title
            })]
          }), barItemsLeft]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.headlineSectionRight,
          children: [barItemsRight, /*#__PURE__*/_jsx(ChevronDown, {
            className: styles.icon
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      id: `section-${id}`,
      role: "region",
      "aria-labelledby": `label-${id}`,
      children: /*#__PURE__*/_jsx(AnimatedCollapsible, {
        open: !!open,
        ChildrenWrapper: ContentWrapper,
        children: children
      })
    })]
  });
};
function ContentWrapper({
  children
}) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.content,
    children: children
  });
}